var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentaxNegativeHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 545 115",
    style: {
      enableBackground: "new 0 0 545 115"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5,69.6V7h16.4v19.2h20.4v14.2H18.9v30.4c0,2.5,1.3,3.8,3.8,3.8h17.8v8.9l-7.1,5.3H21.7 C8.9,88.8,2.5,82.4,2.5,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.3,69.6V45.4c0-12.8,6.4-19.2,19.2-19.2h15.4c12.8,0,19.2,6.4,19.2,19.2v18.1H68.7v7.2 c0,2.5,1.3,3.8,3.8,3.8h31.3v8.9l-7.1,5.3H71.5C58.7,88.8,52.3,82.4,52.3,69.6z M68.7,51h21.1v-6.8c0-2.5-1.3-3.8-3.8-3.8H72.5 c-2.5,0-3.8,1.3-3.8,3.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.3,88.8V26.2h34.6c12.8,0,19.2,6.4,19.2,19.2v43.4h-16.4V44.2c0-2.5-1.3-3.8-3.8-3.8h-17.3v48.4H122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.2,69.6V7h16.4v19.2H229v14.2h-20.4v30.4c0,2.5,1.3,3.8,3.8,3.8h17.8v8.9l-7.1,5.3h-11.6 C198.7,88.8,192.2,82.4,192.2,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.9,88.8c-12.8,0-19.2-6.3-19.2-18.9s6.4-18.9,19.2-18.9h16.4v-6.9c0-2.5-1.3-3.8-3.8-3.8h-25.1v-8.9 l7.1-5.3h19c12.8,0,19.2,6.4,19.2,19.2v43.4H258.9z M256.1,70.8c0,2.5,1.3,3.8,3.8,3.8h15.4V63.7h-15.4c-2.5,0-3.8,1.3-3.8,3.8 V70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303,86.1l20.5-28.9l-19.9-28.2l1.3-2.7H320l12.7,18.7l12.7-18.7h15.1l1.3,2.7l-19.8,28.2l20.4,28.9l-1.3,2.7 h-15.1l-13.3-19.3l-13.3,19.3h-15.1L303,86.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "459.5,67.1 449.6,62.8 388.1,68.1 446.6,81.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "460.6,49.1 447.8,35.1 388.1,48.6 449.6,53.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "448.7,1.8 427.1,1.8 477.6,57.5 427.1,113.2 448.7,113.2 542.5,63.2 542.5,57.5 542.5,51.8  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentaxNegativeHorizontal);
export default __webpack_public_path__ + "static/media/tentax-negative-horizontal.1370d44a455ae11021e3142cdc68153a.svg";
export { ForwardRef as ReactComponent };